export class AuthModel {
    email: string;
    password: string;

    constructor() {
        this.email = '';
        this.password = '';
    }
}
